import { MdAdd } from "react-icons/md";
import { Page } from "../../../components/layout/page/page.component";
import { FloatingActionButton } from "../../../components/ui/fab/fab.component";
import { AlertsSection } from "../sections/alerts.section";
import { ProjectSection } from "../sections/projects.section";
import { colors } from "../../../theme/colors";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FilmProfile } from "../../../models/film-profile.model";
import { axios } from "../../../api/axios";
import { handleResponse } from "../../../utils/functions/http/handleResponse";
import { LinkingAlert } from "../../../models/linking-alert.model";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const [films, setFilms] = useState<FilmProfile[]>([]);
  const [alerts, setAlerts] = useState<LinkingAlert[]>([]);

  useEffect(() => {
    axios
      .get<FilmProfile[]>("/client/get/films/me")
      .then((response) => {
        setFilms(response.data);
      })
      .catch(handleResponse);
  }, []);

  useEffect(() => {
    axios
      .get<{
        film_alerts: LinkingAlert[];
        open_tickets_count: number;
      }>("/client/alerts/me")
      .then((response) => {
        setAlerts(
          response.data.film_alerts.filter(
            (alert) => alert.status === "pending"
          )
        );
      })
      .catch(handleResponse);
  }, []);

  return (
    <Page>
      <ProjectSection films={films} />
      <AlertsSection alerts={alerts} />
      {/* <FloatingActionButton
        onClick={() => {
          navigate("/projects/create/select-type");
        }}
      >
        <MdAdd
          size={window.innerWidth > 768 ? 25 : 20}
          color={colors.white.hex}
        />
        Create Project
      </FloatingActionButton> */}
    </Page>
  );
};
